export * from "./Action";
export * from "./ActionTypes";
export * from "./Callbacks";
export * from "./Filter";
export * from "./IAction";
export * from "./IFilter";
export * from "./ILastIssued";
export * from "./IMuteFilter";
export * from "./INotification";
export * from "./INotificationClient";
export * from "./INotificationHistoryOptions";
export * from "./INotificationService";
export * from "./IPerformedAction";
export * from "./ISnoozeTimer";
export * from "./ISubscription";
export * from "./LastIssued";
export * from "./Meta";
export * from "./Notification";
export * from "./NotificationConfig";
export * from "./NotificationHookTypes";
export * from "./PerformedAction";
export * from "./SnoozeTimer";
export * from "./Subscription";

export type NotificationServiceState = {
	showDrawer: boolean;
	showCenter: boolean;
	poppedOut: boolean;
	position: number;
	toasterMonitor: string;
	/**
	 * Contains the windowName of the most recent UI state change call.
	 */
	mostRecentWindowName?: string;
	overFlowMenu: {
		notification: boolean;
		overflowCount: boolean;
		clickCoordinates: boolean;
	};
};
